import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 40, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

/**
 * Line-by-line scroll reveal. Default renders as a real H1 heading so every
 * page has a single, crawlable, descriptive H1. Pass `as="h2"` for secondary.
 * Pass `as="div"` only for decorative sub-labels.
 */
export function RevealLines({
  lines = [],
  delay = 0.1,
  className = "",
  lineClassName = "",
  as: Tag = "h1",
}) {
  const text = lines.join(" ");
  return (
    <Tag className={className} aria-label={text}>
      {lines.map((line, i) => (
        <span key={i} className="overflow-hidden block">
          <motion.span
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: delay + i * 0.09 }}
            className={`block will-change-transform ${lineClassName}`}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}
